import {ref} from "vue";

export default {
    install(app, options = {}) {
        // Options pour définir la page de redirection par défaut
        const redirectPath = options.redirectPath || '/no-connection'; // Page par défaut

        // État réactif pour suivre la connectivité
        const onlineStatus = app.config.globalProperties.$isOnline = ref(navigator.onLine);

        // Méthode pour mettre à jour l'état
        const updateOnlineStatus = () => {
            onlineStatus.value = navigator.onLine;

            // Redirection si hors ligne
            if (!navigator.onLine) {
                const router = app.config.globalProperties.$router; // Vérifie si Vue Router est disponible
                if (router) {
                    router.push(redirectPath).catch(() => {
                        // Évite les erreurs si l'utilisateur est déjà sur la page cible
                    });
                } else {
                    console.warn('Vue Router non configuré. La redirection ne peut pas être effectuée.');
                }
            }
        };

        // Écouter les événements en ligne et hors ligne
        window.addEventListener('online', updateOnlineStatus);
        window.addEventListener('offline', updateOnlineStatus);

        // Ajouter une propriété globale pour y accéder partout
        app.provide('isOnline', onlineStatus);

        // Nettoyer les écouteurs si nécessaire
        app.unmount = () => {
            window.removeEventListener('online', updateOnlineStatus);
            window.removeEventListener('offline', updateOnlineStatus);
        };
    },
};
